import * as React from 'react';
import TreeTablePicker from 'components/inputs/TreeTablePicker/TreeTablePicker';
import { optionsToFlatTree } from 'components/inputs/TreeTablePicker/helpers';
import { SelectionTreeT } from 'business/definitions';
import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useMemo } from 'react';
import {
    EmptyProjectionDetails,
    ProjectionVentilation,
} from 'routes/BudgetModule/components/BudgetProposal/Resource/Projection/helpers/types';
import { useGetSingleGridFilter } from 'routes/BudgetModule/components/BudgetProposal/Resource/Projection/helpers/dataHelpers';

export type ProjectionFilterProps = {
    data: EmptyProjectionDetails.WithMetadata[];
    filtersState: { [ventilation: string]: SelectionTreeT[] };
    setFiltersState: (value: {
        [ventilation: string]: SelectionTreeT[];
    }) => void;
    title: string;
    labelField: ProjectionVentilation.Labels;
    onFilteredTrackEvent?: string;
};

const StyFilter = styled(Box, {
    name: 'StyFilter',
})(({ theme }) => ({
    border: `thin solid ${theme.palette.primary.main}`,
    borderRadius: '28px',
    padding: '0.2em 0em 0.2em 1em',
    display: 'flex',
    alignItems: 'center',
    width: 'fit-content',
    '& .MuiInputBase-input': {
        fontSize: '12px',
        // improve vertical alignment of the placeholder inside the select
        paddingTop: '5px',
        paddingBottom: '4px',
    },
}));

export default function ProjectionFilter({
    data,
    filtersState,
    setFiltersState,
    title,
    labelField,
    onFilteredTrackEvent,
}: ProjectionFilterProps) {
    const {
        selectedValues,
        setSelectedValues,
        uniqueValues: allOptions,
    } = useGetSingleGridFilter(
        data,
        filtersState,
        setFiltersState,
        labelField,
        onFilteredTrackEvent,
    );

    const formattedOptions = useMemo(
        () =>
            optionsToFlatTree(
                allOptions.map((val) => ({ value: `${val}`, label: `${val}` })),
            ),
        [allOptions],
    );
    return (
        <StyFilter>
            <TreeTablePicker
                gridOptions={formattedOptions}
                selectedValues={selectedValues}
                isLoading={false}
                onChange={setSelectedValues}
                scopeOptions={[]}
                placeholder={title}
                title={title}
                inputProps={{
                    disableUnderline: true,
                }}
            />
        </StyFilter>
    );
}
